export default {
  record: {
    label: 'Screen Recording Projects',
    describe:
      'Through simple parameter adjustment, quickly record a large number of game trial videos online.',
    guide: 'Operation Guide',
    download: 'Download the Mindworks Plug-in',
    newcreate: 'Create Project',
    filter: {
      projectname: 'Project Name',
      versionname: 'Version Name',
      projectid: 'Project ID',
      versionid: 'Version ID',
      search: 'Search',
      projectstatus: 'Project Status',
      uploaded: 'Uploaded',
      waitingupload: 'To Be Uploaded',
      versionstatus: 'Version Status',
      editing: 'Editing',
      exporting: 'Exporting',
      exported: 'Exported',
      exportfailed: 'Export Failed',
      cancelled: 'Cancelled',
    },
    table: {
      nameid: 'Project/Version Name and ID',
      operation: {
        name: 'Operations',
        createtips: 'Create Version',
        lockedtips:
          'The screen recording asset file is locked, click to unlock it.',
        locktips:
          'The screen recording asset file is unlock, click to locked it.',
        copytips: 'Copy',
        edit: 'Edit',
        details: 'View Details',
        delete: 'Delete',
        exporthistory: 'Export History',
      },
      productname: 'Product Name',
      parameters: 'Number of Parameters',
      duration: 'Version Duration',
      status: 'Project/Version Status',
      createVersion: 'Create Project',
      unlock: {
        label: 'Unlock the screen recording asset file',
        describe:
          'If the game content was changed in the unity project, the historical version of this project may display in error.',
      },
      copyproduct: 'Duplicate Project',
      delete: {
        label: 'Delete Project',
        describe:
          "Delete the screen recording project, the screen recording asset file and version in the project will be deleted together. But the generated video works of the project will not be affected. If the project is synchronizing screen recording compression or exporting videos, the delete operation may fail. This can't be undone. Are you sure to delete?",
      },
      version: {
        delete: 'Delete this Version',
        describe: "This can't be undone. Are you sure to delete?",
      },
    },
    createproject: 'Create Screen Recording Project',
    editproject: 'Edit Screen Recording Project',
    basic: {
      information: 'Basic Information',
      productName: 'Promoted Product',
      productNameTips: 'Please input Project Name',
      projectName: 'Project Name',
      projectNameTips: 'Please input Project Name',
      placeholder: 'Please input Version Name',
      keywords: 'Please Search Keywords to Select',
      adaptation: 'Game Adaptation Orientation',
      portrait: 'Portrait',
      landscape: 'Landscape',
      describe:
        'In order to ensure a better game recording effect, you can select the adaptation Orientation of the game you want to import.',
      noProject: 'No Project to Choose',
      paramsEmptyTips:
        'You don\'t have parameter yet. You can create it in "Parameters for Recording" for subsequent use.',
      parameters: {
        title: 'Recording Parameters',
        describe:
          'If the project has uploaded the screen recording project file, the newly added recording parameters will not be applied immediately on your current version editing page. Engineers need to define these new parameters in screen recording project file and upload them again.',
      },
      existing: 'Duplicate from My Project',
      default: 'Duplicate from Parameters Dictionary',
      new: 'Create Parameter',
      total: '{total} Parameters',
      table: {
        name: 'Name',
        achieve: 'Parameter Status',
        describe:
          'This parameter is not defined in Unity and will not be displayed on the Screen recorder page.',
        operation: 'Operations',
        delete:
          "Removal of parameters not defined in Unity can't be undone. Are you sure to delete?",
        note: 'Description',
        selected: 'Selected',
        content: 'Options',
        defaults: 'Defaults',
        hidetips: 'Click to Hide',
        showtips: 'Click to Show',
      },
    },
    projectDrop: {
      recordPackage: 'Screen Recording Asset File',
      packageName: 'Name',
      packageStatus: 'Status',
      packageStatus1: 'Locked',
      packageStatus2: 'Unlocked',
      packageUpdateTime: 'Updated Time',
      packageSize: 'Size',
    },
    cover: {
      title: 'Duplicate Parameters',
      info: 'The selected parameter has the same name as the existing parameter and cannot be added to the project.<br /> Please go back and modify the existing parameters of the project, or click the skip button in the lower right corner to skip the existing conflict items and continue to add.',
      info1: 'Repeated Parameters',
      confirm: 'Skip',
    },
    promotional: {
      create: 'Add Promoted Product',
      producttype: 'Product Type',
      platformtype: 'Platform Type',
      ios: {
        placeholder: 'Please input the Apple App Store link',
      },
      android: {
        placeholder: 'Please input the Google Play or Android App Store link',
      },
      website: {
        placeholder: 'Please input the link.',
      },
    },
    existing: {
      select: 'Duplicate from My Project',
      placeholder: 'Please Search Project Name or ID to Select',
      parameters: 'Project Parameter',
      table: {
        name: 'Name',
        note: 'Description',
        type: 'Parameter Type',
        content: 'Options',
        defaults: 'Defaults',
        emptyTips: 'Please Select Project',
      },
    },
    parameter: {
      select: 'Select From Default Parameter',
      placeholder: 'Search Parameter Name',
    },
    select: {
      single: 'Radio',
      multiple: 'Checkbox',
      radio: 'Single Selection Dropdown',
      multi: 'Multiple Selection Dropdown',
      numvalue: 'Value',
    },
    screen: {
      create: 'Create Parameter for Recording',
      describe:
        'After editing the parameters, the developer needs to refresh and view the project information in the plug-in, otherwise the editing may fail.',
      parametername: 'Parameter Name',
      placeholder: 'Please input Parameter Name',
      description: 'Please input Description',
      edit: 'Edit Parameter for Recording',
      table: {
        sort: 'Sort',
        content: 'Content',
        add: 'Add Option',
        tips: 'At Least 2 Options',
        tips1: 'Set as Default',
      },
      preview: 'Preview',
      option: 'New Option',
    },
    operation: {
      guide: {
        label: 'Want to quickly start creating screen recording projects?',
        describe:
          'Try to follow the guidelines below to create your first screen recording project!',
        step1: {
          label: 'Create Screen Recording Project',
          describe: 'Create project and add parameters for recording you need.',
          confirm: "Haven't installed the Mindworks plug-in yet?",
          view: 'Download Plugin Guide',
        },
        step2: {
          label:
            'Log in to the Mindworks plug-in in Unity to view the screen recording project information.',
          describe:
            'Through the plug-in settings of Mindworks in Unity, the screen recording files are synchronized to the Playturbo platform.',
        },
        step3: {
          label: 'Record Online and Adjust Parameters',
          describe:
            'Through simple parameter adjustment, quickly record a large number of game trial videos online.',
        },
        step4: {
          label: 'Finish Editing, Export Video',
          describe: 'Done!',
        },
      },
    },
  },
}
